<template>
  <div class="me">
    <div class="title themeColor">个人中心</div>
    <div class="me-top topBg clearfix">
      <div class="userInfo-box">
        <div class="userInfo" @click="toPages('/my/personal')">
          <div class="info">
            <span>{{ userName }} <i v-if="userNumber !== ''">({{ userNumber }})</i></span>
            <span>{{ userMobile }}</span>
          </div>
          <img src="../../assets/images/me/next.png" alt="">
        </div>
        <div class="cart">
          <div class="balance" @click="toPages('/my/balance')">
            <span>{{ balance }}</span>
            <span>余额</span>
          </div>
          <div class="other">
            <div class="item" @click="toPages('/my/orderRecord', 0)">
              <div class="icon">
                <img src="../../assets/images/me/my_order.png" alt="">
              </div>
              <span>我的订单</span>
            </div>
            <div class="item" @click="toPages('/my/orderRecord', 1)">
              <div class="icon">
                <img src="../../assets/images/me/my_order_pay.png" alt="">
              </div>
              <span>待支付</span>
              <div class="dot" v-if="awaitPay === 1"></div>
            </div>
            <div class="item" @click="toPages('/my/orderRecord', 2)">
              <div class="icon">
                <img src="../../assets/images/me/my_order_delivery.png" alt="">
              </div>
              <span>配送中</span>
              <div class="dot" v-if="delivery === 1"></div>
            </div>
            <div class="item" @click="toPages('/my/orderRecord', 3)">
              <div class="icon">
                <img src="../../assets/images/me/my_order_complete.png" alt="">
              </div>
              <span>已完成</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="box">
        <div class="item" @click="goRelation">
          <span>联系我们</span>
          <img src="../../assets/images/me/next.png" alt="">
        </div>
        <div class="item" @click="signOut">
          <span>退出登录</span>
          <img src="../../assets/images/me/next.png" alt="">
        </div>
      </div>
    </div>
    <bottom-nav></bottom-nav>
  </div>
</template>
<script>
import bottomNav from "../../components/bottomNav.vue";
import {Dialog, Toast} from "vant";

export default {
  name: "Index",
  data() {
    return {
      userMobile: '',
      userName: '',
      userNumber: '',
      balance: '',
      awaitPay: 0,//待支付
      delivery: 0,//已完成
    };
  },
  created() {
    //  this.getToken();
  },
  mounted() {
    this.getUserInfo()
    this.userGoodStatus()
  },
  methods: {
    //获取订单状态
    userGoodStatus() {
      this.$post('user/index').then(result => {
        this.awaitPay = result.data.notPaid;
        this.delivery = result.data.delivery;
      });
    },
    toPages(url, orderId) {
      this.$router.push({path: url, query: {orderId}})
    },
    //退出登录
    signOut() {
      let token = localStorage.getItem('user_token');
      if (token) {
        Dialog.confirm({
          message: "确定退出登录吗？",
          confirmButtonColor: '#126AFC',
          overlayStyle: {'z-index': 999}
        }).then(() => {
          this.$post('user/logout').then(res => {
            if (res.status === 200) {
              localStorage.removeItem('user_token');
              localStorage.removeItem('user_type');
              sessionStorage.removeItem("skipAddress")
              this.$router.push('/');
            } else {
              Toast(res.msg);
            }
          })
        }).catch(() => {
        })
      } else {
        return Toast('未登录');
      }

    },

    goRelation() {
      this.$router.push('/my/relation')
    },

    getUserInfo() {
      this.$post('user/info').then(res => {
        if (res.status == 200) {
          let data = res.data
          this.$data.userMobile = data.userMobile
          this.$data.userName = data.userName
          this.$data.userNumber = data.userNumber
          this.$data.balance = data.balance || '0.00'
        }
      })
    },
  },
  components: {
    bottomNav,
  },
};
</script>
<style lang="less" scoped>
.me {
  .title {
    height: 44px;
    font-size: 18px;
    text-align: center;
    line-height: 44px;
  }

  .me-top {
    height: 200px;

    .userInfo-box {
      padding: 0 15px;
      box-sizing: border-box;

      .userInfo {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 9px;
          height: 18px;
        }

        .info {
          display: flex;
          flex-direction: column;
          font-weight: bold;

          span:nth-child(1) {
            font-size: 20px;

            i {
              font-style: normal;
            }
          }

          span:nth-child(2) {
            font-size: 15px;
            margin-top: 14px;
          }
        }
      }
    }

    .cart {
      height: 80px;
      margin-top: 25px;
      background: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      font-size: 12px;
      border-radius: 8px;

      .balance {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;

        span:nth-child(1) {
          font-size: 18px;
        }

        span:nth-child(2) {
          margin-top: 10px;
          color: #333333;
        }
      }

      .other {
        display: flex;

        .item {
          width: 59px;
          display: flex;
          flex-direction: column;
          align-items: center;
          border-left: 1px solid #EEEEEE;
          position: relative;

          .dot {
            width: 10px;
            height: 10px;
            background: #FC3912;
            border-radius: 50%;
            position: absolute;
            top: -5px;
            right: 7px;
          }

          .icon {
            height: 23px;
          }

          span {
            margin-top: 8px;
          }
        }

        .item:nth-child(1) {
          img {
            width: 21px;
            height: 23px;
          }
        }

        .item:nth-child(2) {
          img {
            width: 24px;
            height: 20px;
          }
        }

        .item:nth-child(3) {
          img {
            width: 24px;
            height: 19px;
          }
        }

        .item:nth-child(4) {
          img {
            width: 21px;
            height: 23px;
          }
        }
      }
    }
  }

  .wrap {
    padding: 0 15px;
    box-sizing: border-box;

    .box {
      background: #FFFFFF;
      border-radius: 8px;
      padding: 0 20px;
      box-sizing: border-box;

      .item {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        border-bottom: 1px solid #EEEEEE;

        img {
          height: 12px;
        }
      }

      .item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>